import { FJGoogleDrive } from 'fj-social-media-library';
import FJMediaImportModel from '@src/lib/FJMediaImportModel';
import { FJMediaImportModelType } from '@src/constants/FJMediaImportConstant';
import FJConfig from '@src/config/FJConfig.ts';
import { SOCIAL_KEY } from '@src/constants/FJShareSocialConstant.ts';

class FJGoogleDriveImportStore {
    public getFiles(type: string, accessToken: string, folder: string, pageToken: any, signal: any) {
        const filterInvalidModel = (model: any) => {
            if (model.modelType === FJMediaImportModelType.file) {
                if (!model.type) {
                    return false;
                } else if (model.type === 'VIDEO') {
                    if (model.duration < 0.1 || model.size > FJConfig.mediaMaxSize) {
                        return false;
                    }
                } else if (model.type === 'IMAGE' || model.type === 'GIF') {
                    if (!model.thumbnail) {
                        return false;
                    }
                }
            }
            return true;
        };

        return new Promise(async (resolve, reject) => {
            if (!accessToken) {
                reject('IMPORT_MEDIA_AUTH_ERROR');
                return;
            }

            switch (type) {
                case SOCIAL_KEY.GOOGLE_DRIVE:
                    // 文件类型在请求时做了筛选，只允许文件夹、视频和图片
                    FJGoogleDrive.getFiles(folder, pageToken, accessToken, signal)
                        .then((json: any) => {
                            const files = json['files'] ?? [];
                            const newModels = files
                                .filter((file: any) => !file['mimeType']?.includes('svg'))
                                .map((file: any) => FJMediaImportModel.fromGoogleDrive(file))
                                .filter(filterInvalidModel);
                            const nextPageToken = json['nextPageToken'] ?? null;
                            resolve({ newModels, nextPageToken });
                        })
                        .catch(e => {
                            reject(this._handleImportMediaAuthError(type, e));
                        });
                    break;
                default:
                    break;
            }
        });
    }

    private _handleImportMediaAuthError(type: string, error: any) {
        switch (type) {
            case SOCIAL_KEY.GOOGLE_DRIVE:
                if (error?.status === 401 || error?.status === 403) {
                    return 'IMPORT_MEDIA_AUTH_ERROR';
                }
                break;
        }
        return error;
    }
}

const manager = new FJGoogleDriveImportStore();

export default manager;
